// @flow
// Consider notifying other departments (mobile devs, BE / DnA due to booking process)
import type JourneyType from "../../records/Journey"

// Show middlename (may not be required)
export const shouldShowMiddlename = (
  journey: JourneyType,
  nationality: string,
  middlename: ?string = "",
) =>
  Boolean(middlename) ||
  (nationality === "ru" && journey.getCountries().every(country => country === "ru"))
